// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marketing-platform-cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  min-height: 22px;
}

.marketing-platform-cell--empty {
  color: var(--text3);
}

.marketing-platform-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  color: var(--platform-brand-color, currentColor);
}

.marketing-platform-icon svg {
  width: 18px;
  height: 18px;
  display: block;
}

.marketing-platform-icon--instagram {
  background: linear-gradient(45deg, #f58529, #dd2a7b 50%, #8134af);
  border-radius: 6px;
  color: #fff;
}

.marketing-platform-icon--instagram svg {
  width: 16px;
  height: 16px;
}

.marketing-platform-icon--threads {
  background: #000;
  border-radius: 6px;
  color: #fff;
}

.marketing-platform-icon--threads svg {
  width: 14px;
  height: 14px;
}

.marketing-platform-icon--linkedin svg {
  width: 22px;
  height: 22px;
}

.marketing-platform-icon--google {
  color: unset;
}

.marketing-platform-icon--google svg {
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/mi/MarketingPlatformCell.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iEAAiE;EACjE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".marketing-platform-cell {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  min-height: 22px;\n}\n\n.marketing-platform-cell--empty {\n  color: var(--text3);\n}\n\n.marketing-platform-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  color: var(--platform-brand-color, currentColor);\n}\n\n.marketing-platform-icon svg {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n.marketing-platform-icon--instagram {\n  background: linear-gradient(45deg, #f58529, #dd2a7b 50%, #8134af);\n  border-radius: 6px;\n  color: #fff;\n}\n\n.marketing-platform-icon--instagram svg {\n  width: 16px;\n  height: 16px;\n}\n\n.marketing-platform-icon--threads {\n  background: #000;\n  border-radius: 6px;\n  color: #fff;\n}\n\n.marketing-platform-icon--threads svg {\n  width: 14px;\n  height: 14px;\n}\n\n.marketing-platform-icon--linkedin svg {\n  width: 22px;\n  height: 22px;\n}\n\n.marketing-platform-icon--google {\n  color: unset;\n}\n\n.marketing-platform-icon--google svg {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
